import React from 'react';

export default function Twitter(props) {
  return <img src="/images/twitter.svg" alt="Twitter" {...props} />;
}
